export const columns: any = [
  {
    title: 'Date',
    cssWidth: '170px',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'date',
  },
  {
    title: 'Invoice no.',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'invoice_number',
  },
  {
    title: 'Download',
    cssWidth: '142px',
    sortable: false,
    sort: 'desc',
    active: false,
    col: 'download',
  },
];
